import React from "react";
import PropTypes from "prop-types";
import SkeletonLoader from "UIComponents/SkeletonLoader";
import classes from "./EventDetailsLoader.scss";

const EventDetailsLoader = ({ testId = "event-details-loader" }) => {
  return (
    <div className={classes.loaderContainer} data-test-id={testId}>
      {/* Header with hamburger icon and close button */}
      <div className={classes.header}>
        <div className={classes.headerLeft}>
          <SkeletonLoader width="100%" height="20px" />
        </div>
      </div>

      {/* Event title */}
      <div className={classes.title}>
        <SkeletonLoader width="85%" height="20px" />
      </div>

      {/* For label */}
      <div className={classes.forLabel}>
        <SkeletonLoader width="50px" height="18px" />
      </div>

      {/* Date pickers */}
      <div className={classes.datePickers}>
        <SkeletonLoader width="85%" height="20px" borderRadius="4px" />
      </div>

      {/* Participants section */}
      <div className={classes.participantsSection}>
        <div className={classes.sectionHeader}>
          <div className={classes.sectionLeft}>
            <SkeletonLoader width="200px" height="18px" />
            <SkeletonLoader width="95%" height="16px" />
          </div>
        </div>
      </div>

      {/* Created by section */}
      <div className={classes.createdBySection}>
        <div className={classes.userInfo}>
          <SkeletonLoader width="40px" height="40px" borderRadius="50%" />
          <div className={classes.userDetails}>
            <SkeletonLoader width="70px" height="14px" />
            <SkeletonLoader width="160px" height="18px" />
          </div>
        </div>
      </div>
    </div>
  );
};

EventDetailsLoader.propTypes = {
  testId: PropTypes.string,
};

export default EventDetailsLoader;
